import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Icon, { IconName } from 'src/components/ui/Icon/Icon';
import styles from './SimpleFooter.module.scss';

export interface SimpleFooterProps {
  className?: string;
  socialIcons?: {
    icon: IconName;
    href: string;
  }[];
}

const SimpleFooter: React.FC<SimpleFooterProps> = ({ socialIcons = [], className }) => {
  return (
    <div className={classNames(styles.root, className)}>
      <p className="typo-text-14">© {new Date().getFullYear()} Weship. All right reserved </p>
      <div className={styles.socialIcons}>
        {socialIcons.length > 0 &&
          socialIcons.map(s => (
            <Link key={Math.random()} to={s.href} target="_blank">
              <Icon name={s.icon} />
            </Link>
          ))}
      </div>
    </div>
  );
};

export default SimpleFooter;
